import { Link } from 'react-router-dom';

const timeline = [
  { year: '2017', event: "Founded in Banjara Hills, Hyderabad — India's first café with an in-house coffee roasting unit." },
  { year: '2019', event: 'Expanded to Kolkata, breathing life back into the storied South India Club.' },
  { year: '2021', event: 'The birth of the Cranberry Coffee — a trademarked revolution in Indian specialty coffee.' },
  { year: '2022', event: 'Crossing 11 locations, from the pink walls of Jaipur to the heart of Delhi.' },
  { year: '2024', event: 'Helsinki, Finland — taking Indian soil and soul to the Nordic coffee capital.' },
];

const values = [
  { title: 'Only 80+ Scored Beans', body: 'Every bean we roast is specialty grade. We never compromise on quality — not for price, not for availability.' },
  { title: 'Farm-Direct Ethics', body: 'We pay premium prices directly to our farmers. Preserving the value chain from crop to cup is our foundation.' },
  { title: 'The Giesen Heartbeat', body: 'Our in-house roasting units aren’t just machines; they are the soul of every cup we pour.' },
  { title: 'Indian Minimalism', body: 'Every Roastery is designed around its city — drawing from local heritage and handmade Indian craft.' },
];

export default function About() {
  return (
    <div className="page-enter overflow-x-hidden">
      
      {/* Cinematic Hero */}
      <div className="relative h-[90vh] flex items-center overflow-hidde">
        <div className="absolute inset-0 bg-[url('https://roasterycoffee.co.in/wp-content/uploads/2025/12/1-banner-scaled.png')] bg-cover bg-center scale-110 animate-pulse-slow"></div>
        <div className="absolute inset-0"></div>
        
        <div className="relative z-10 px-8 md:px-24 w-full max-w-6xl">
          <p className="text-[10px] tracking-[0.4em] uppercase text-sand/60 mb-8 animate-fade-in">Established 2017</p>
          <h1 className="font-serif font-[700] font-light text-maroon leading-[1] mb-8" style={{ fontSize: 'clamp(3rem, 8vw, 6rem)' }}>
            The Soul of the <br />
            Indian Bean.
          </h1>
          <p className="text-lg font-light text-maroon leading-relaxed max-w-xl border-l border-sand/30 pl-8">
            Roastery Coffee House was founded with a single stubborn belief — that India grows
            some of the world's finest coffee, and that every Indian deserves to experience it in its purest form.
          </p>
        </div>
      </div>

      {/* Philosophy Section */}
      <section className="py-32 px-8 md:px-24 flex flex-col items-center text-center">
        <div className="max-w-3xl">
          <h2 className="font-serif text-4xl md:text-5xl font-light text-maroon mb-12 italic">
            "We want to go slow and make an impact."
          </h2>
          <div className="w-16 h-px bg-maroon/20 mx-auto mb-12"></div>
          <p className="text-xs tracking-[0.3em] uppercase text-maroon/40 mb-2">Nishant Sinha</p>
          <p className="text-[10px] text-maroon/30">Founder & MD, Roastery Coffee House</p>
        </div>
      </section>

      {/* Soulful Timeline */}
      <section className="bg-maroon py-32 px-8 md:px-24">
        <div className="flex flex-col md:flex-row justify-between items-end mb-20 gap-8">
          <div>
            <p className="text-[10px] tracking-[0.3em] uppercase text-sand/40 mb-4">Chronology</p>
            <h2 className="font-serif text-5xl font-light text-white italic">The Journey</h2>
          </div>
          <p className="text-sand/50 max-w-xs text-sm font-light leading-relaxed italic">
            From a single bungalow in Hyderabad to the cobblestones of Helsinki.
          </p>
        </div>

        <div className="space-y-px bg-white/5">
          {timeline.map((item, i) => (
            <div key={item.year} className="group grid grid-cols-1 md:grid-cols-[150px_1fr] hover:bg-white/5 transition-all duration-700 items-center">
              <div className="py-12 border-r border-white/10 text-center">
                <span className="font-serif text-3xl font-light text-sand/30 group-hover:text-sand transition-colors duration-500">
                  {item.year}
                </span>
              </div>
              <div className="px-8 md:px-16 py-12">
                <p className="text-lg font-light text-white/70 group-hover:text-white transition-colors duration-500 max-w-2xl">
                  {item.event}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Values Grid */}
      <section className="py-32 px-8 md:px-24 bg-white">
        <div className="mb-20">
          <p className="text-[10px] tracking-[0.3em] uppercase text-maroon/40 mb-4">Foundations</p>
          <h2 className="font-serif text-5xl font-light text-maroon italic">What We Stand For</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {values.map((v, i) => (
            <div key={i} className="group flex flex-col">
              <span className="font-serif text-6xl text-maroon mb-8 group-hover:text-maroon/70 transition-colors">0{i+1}</span>
              <h3 className="font-serif text-xl text-maroon mb-4">{v.title}</h3>
              <p className="text-sm leading-relaxed text-maroon/76 font-light">{v.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Cinematic CTA */}
      <section className="relative h-[60vh] flex items-center justify-center text-center px-8">
        <div className="absolute inset-0 bg-maroon/80">
             <div className="absolute inset-0 bg-[url('https://roasterycoffee.co.in/wp-content/uploads/2025/12/Artboard-73@4x-1024x397.png')] bg-cover bg-center opacity-20 grayscale"></div>
        </div>
        
        <div className="relative z-10">
          <h3 className="font-serif text-4xl md:text-6xl text-white font-light mb-12">
            Taste the <span className="italic text-white bold-[900]">Quiet Luxury.</span>
          </h3>
          <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
            <Link to="/shop" className="w-64 py-5 bg-white text-maroon text-[10px] tracking-[0.3em] uppercase font-bold hover:bg-sand transition-all shadow-xl">
              Shop the Collection
            </Link>
            <Link to="/cafes" className="w-64 py-5 border border-white hover:text-maroon text-white text-[10px] tracking-[0.3em] uppercase font-bold hover:bg-white transition-all">
              Visit a Roastery
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
}